@import '~@customink/design-tokens/build/scss/variables.scss';

.ghf {
  &-menu {
    &-listItem {
      list-style-type: none;
      display: flex;
      padding: 4px $spacing-16;
      align-items: center;
      align-self: stretch;
      border-radius: 4px;
    }
    &-link {
      font-size: $typography-body-short1-size;
      text-decoration: none;
      color: $color-gray-slate-dark;
      &:link, &:visited {
        color: $color-gray-slate-dark;
      }
      &:hover {
        color: $color-blue-default;
      }
    }
  }
}
